export const SET_VERSION = 'SET_VERSION'
export const SET_VERSION_LOADING = 'SET_VERSION_LOADING'
export const SET_VERSION_ERROR = 'SET_VERSION_ERROR'

export const actions = {
  setVersion(dispatch, payload) {
    return dispatch({ type: SET_VERSION, payload })
  },
  setVersionLoading(dispatch, payload) {
    return dispatch({ type: SET_VERSION_LOADING, payload })
  },
  setVersionError(dispatch, payload) {
    return dispatch({ type: SET_VERSION_ERROR, payload })
  },
}
